import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export function useTheme() {
  // Initialize with light theme as default
  const [theme, setTheme] = useState<Theme>('light');

  const persist = (t: Theme) => {
    localStorage.setItem('theme', t);
    document.documentElement.setAttribute('data-theme', t);
    // Also persist to a cookie so server-rendered pages (blog SSR) can match theme on refresh.
    // No UI change; just makes refresh/direct loads consistent.
    document.cookie = `theme=${encodeURIComponent(t)}; Path=/; Max-Age=31536000; SameSite=Lax`;
  };

  // Load theme from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as Theme | null;
    
    // Check for saved preference or system preference
    if (savedTheme) {
      setTheme(savedTheme);
      persist(savedTheme);
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
      persist('dark');
    }
  }, []);

  // Toggle theme function
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    persist(newTheme);
  };

  return { theme, toggleTheme };
}

